import bootstrap from "./bootstrap"
import Vue from 'vue'
import { call, get } from 'vuex-pathify'
import helpersMixin from './mixins/helpers'
import plugins from "./plugins"
import store from "./store"
import ux from "./ux.js"
import ChartFiltering from "./components/menus/chartFiltering"
import ClientDropdown from "./components/menus/clients/dropdown"
import Logout from "./components/logout"
import Mobilemenu from "./components/menus/mobilemenu"
import TopChartOrdering from "./components/menus/topChartOrdering"
import Togglefilters from "./components/menus/togglefilters"
import ExportReport from "./components/exportReport"

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./pages', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    store,

    mixins: [
        helpersMixin
    ],

    components:{
        ChartFiltering,
        ClientDropdown,
        Logout,
        Mobilemenu,
        ExportReport,
        Togglefilters,
        TopChartOrdering,
    },

    computed: {
        client: get('auth/client'),

        apiToken() {
            let token = document.head.querySelector('meta[name="api-token"]')

            if (token) {
                return token.content
            }

            return null
        }
    },

    created() {
        if (this.apiToken) {
            this.setApiToken(this.apiToken)
        }
    },

    async mounted() {
        if (this.apiToken) {
            await this.loadUser()
        }
    },

    methods: {
        loadUser: call('auth/loadUser'),

        setApiToken(token) {
            window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        },
    }
}).$mount('#app');
